// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5d4e7af2","732":"fa1afea8","977":"f4e04f9f"}[chunkId] + ".chunk.js";
};